{
  "schema_version": 1,
  "task_id": "L5-CREATIVE-STARTER-SURFACE-001",
  "status": "creative-starter-ready",
  "generated_at": "2026-07-31T10:20:00+08:00",
  "authority_boundary": {
    "observational_only": true,
    "formal_gate_replacement": false,
    "mutation_authority": false,
    "approval_authority": false,
    "stores_user_decisions": false,
    "collects_secrets": false,
    "cloud_sync": false,
    "ecosystem_publish": false,
    "external_distribution": false,
    "external_write": false,
    "paid_action": false,
    "secret_storage": false,
    "deployment": false,
    "runtime_activation": false,
    "model_call": false,
    "tool_call": false,
    "task_completion_authority": false
  },
  "summary": {
    "starter_path_count": 3,
    "can_execute_now_count": 0,
    "external_effect_count": 0,
    "secret_values_embedded_count": 0,
    "task_spec_draft_only": true,
    "local_model_advisory_only": true,
    "runtime_preview_only": true
  },
  "start_paths": [
    {
      "id": "idea-to-task-spec",
      "title_zh": "从一句想法开始",
      "title_en": "Start from one idea",
      "intent_zh": "把“我想做什么”整理成目标、非目标、验收、风险和回滚。",
      "intent_en": "Turn “what I want to build” into goals, non-goals, acceptance, risks and rollback.",
      "input_zh": "一句话 Brief",
      "input_en": "One-line brief",
      "output_zh": "Task Spec 草稿 + 验收清单",
      "output_en": "Task Spec draft + acceptance checklist",
      "current_allowed_effect": "render_readonly_planning_path",
      "can_execute_now": false,
      "gate": "Task Spec + Evidence",
      "uses": [
        "AIOS Home",
        "Context Pack",
        "Task Spec"
      ]
    },
    {
      "id": "local-model-proposal",
      "title_zh": "让本地模型给方案",
      "title_en": "Ask the local model for a proposal",
      "intent_zh": "把 qwen2.5-coder:7b 的输出限制为 proposal，进入 BEA 策略层筛选。",
      "intent_en": "Constrain qwen2.5-coder:7b output to a proposal and pass it through BEA policy screening.",
      "input_zh": "Brief + 当前状态",
      "input_en": "Brief + current state",
      "output_zh": "模型建议 + 风险 + 下一 Gate",
      "output_en": "Model suggestion + risk + next Gate",
      "current_allowed_effect": "display_advisory_proposal_only",
      "can_execute_now": false,
      "gate": "BEA policy simulation",
      "uses": [
        "qwen2.5-coder:7b",
        "BEA Router",
        "Policy"
      ]
    },
    {
      "id": "governed-runtime-preview",
      "title_zh": "进入受控 Runtime 预览",
      "title_en": "Enter governed Runtime preview",
      "intent_zh": "把候选动作放入 preview-only 队列，先看权限、Evidence、Reviewer 和回滚。",
      "intent_en": "Place a candidate action into the preview-only queue and inspect permissions, Evidence, Reviewer and rollback first.",
      "input_zh": "候选动作意图",
      "input_en": "Candidate action intent",
      "output_zh": "受控动作预览 + 安全锁结果",
      "output_en": "Governed action preview + safety-harness result",
      "current_allowed_effect": "preview_only_no_runtime_activation",
      "can_execute_now": false,
      "gate": "Approval simulation + safety harness",
      "uses": [
        "Desktop Runtime Bridge",
        "Approval Preview",
        "External Action Safety Harness"
      ]
    }
  ],
  "creative_loop_contract": {
    "steps_zh": [
      "输入想法",
      "AIOS 生成 Task Spec 草稿",
      "本地模型只做建议",
      "Runtime 只做 preview",
      "Evidence / Reviewer / 回滚齐备后再进入正式 Gate"
    ],
    "steps_en": [
      "Enter an idea",
      "AIOS drafts a Task Spec",
      "Local models only advise",
      "Runtime stays preview-only",
      "Formal Gate starts only after Evidence, Reviewer and rollback are ready"
    ],
    "default_blockers": [
      "no_execute_button",
      "no_runtime_activation",
      "no_external_write",
      "no_secret_collection",
      "no_decision_storage",
      "no_paid_action"
    ]
  },
  "handoff_integration": {
    "visible_capability": "creative-starter-readonly",
    "evidence": "artifacts/evidence/L5-CREATIVE-STARTER-SURFACE-001",
    "project_status": "config/aios-project-status.json",
    "final_handoff_pack": "config/l5-final-handoff-pack.json",
    "completion_map": "config/l5-completion-map.json"
  }
}
